export default __webpack_public_path__ + "static/media/clear-sky.1f771561.jpg";